import React from 'react'
import { Switch } from 'react-router-dom'

import Route from '../lib/route'

import SignIn from './auth/signin'
import SignOut from './auth/signout'
import MyPage from './auth/mypage'
import PageNotFound from "../pages/page-not-found";

export default () => {
  return (
    <Switch>
      <Route path="/auth/signin" exact contents id="auth-signin" component={SignIn} />
      <Route path="/auth/signout" exact contents id="auth-signout" component={SignOut} />
      <Route path="/auth/mypage" auth exact contents id="auth-mypage" component={MyPage} />
      <Route component={PageNotFound} />
    </Switch>
  )
}
